import React, { useEffect, useRef, useCallback, useState} from 'react';
import {connect} from 'react-redux';
import './xy.scss';

const XYInterface = ({zobject, attributes, width, height, x, y}) => { 
    let ref = useRef(undefined);
    let [coords, setCoords] = useState(zobject.effect.coordinates);
    let [moving, setMoving] =  useState(false);

    const onMouseMove = useCallback((e, force) => {
        if (moving === undefined && !force) {
            return;
        }
        if (force) {
            // e.stopPropagation();
            setMoving(true);
        }
        let rect = ref.current.getBoundingClientRect();
        let x = (e.clientX - rect.left)/width;
        let y = 1-(e.clientY - rect.top)/(height-40);
        zobject.effect.setXY(x,y,moving);
        setCoords([...zobject.effect.coordinates]);
    }, [moving, setMoving, setCoords, width, height]);

    let backgroundColor = attributes["primary-color"] || "black";
    let style = {
        backgroundColor
    };

    if (!coords) {
        return '';
    }

    let names = [];
    let colors = [];
    for (let i=0; i < zobject.effect.numberOfCoordinates; i++) {
        names.push(zobject.attributes["coordinate-name-" + (i+1)]);
        colors.push(zobject.attributes["coordinate-color-" + (i+1)]);
    }

    let xaxis = zobject.attributes["x-axis"];
    let yaxis = zobject.attributes["y-axis"];
    return (
        <div className="multi-xy">
          <div className="x-axis">{xaxis}</div>
          <div className="y-axis">{yaxis}</div>
        <svg
          style={style}
          ref={ref}
          onMouseUp={e => setMoving(undefined)}
          onMouseLeave={e => setMoving(undefined)}
          onMouseDown={e => onMouseMove(e, true)}
          onMouseMove={onMouseMove}
          width={width} height={height-40} className="xy-interface">
          {coords.map((coord, i) => 
          <circle
            fill={attributes["coordinate-color-" + (i+1)]}
            onMouseDown={(e) => {
                e.stopPropagation();
                setMoving(i);
            }}
            cx={coord.x*width} cy={(1-coord.y)*(height-40)} r={10}/>)}
        </svg>
        <div className="legend">
        {names.map((name,i) =>
            <div className="legend-type">
              <div style={{backgroundColor: colors[i]}} className="dot"/>
              <div className="legend-name">
                {name}
              </div>
            </div>
        )}
            </div>
        </div>
    );
};

const mapStateToProps = (state, props) => {
    let {zobject} = props;
    if (!zobject.effect) {
        return {};
    }
  return {
      width: zobject.width,
      height: zobject.height,
      coordinates: zobject.effect.coordinates,
      attributes: zobject.attributes
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(XYInterface);
